import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import SKUsModifiedByMonthByUserList from './components/month/SKUsModifiedByMonthByUserList';
import SKUsModifiedByWeekByUserList from './components/week/SKUsModifiedByWeekByUserList';

function SKUsModifiedByUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="SKUs modified by user"
      MonthList={SKUsModifiedByMonthByUserList}
      WeekList={SKUsModifiedByWeekByUserList}
    />
  );
}

export default SKUsModifiedByUser;
